import React from 'react';
import { Container, Alert } from 'reactstrap';

const AccessDenied = () => (
  <Container style={{ paddingTop: '2%' }}>
    <Alert color="danger" style={{ padding: '10%', textAlign: 'center' }}>
      <h2>
        The Logged in User does not have required privileges
      </h2>
    </Alert>
  </Container>
);

export default AccessDenied;
